/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2020 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React, { ReactNode } from 'react';

import { OperatorLink, PhoneLink } from '../styles/components';

interface Props {
  children: ReactNode;
  inactive: boolean;
  to?: string;
  onClick?: () => void;
}

const OperatorWrapper = ({ children, inactive, to, onClick }: Props) =>
  inactive ? (
    <>{children}</>
  ) : to ? (
    <PhoneLink href={`tel:${to}`} onClick={onClick}>
      {children}
    </PhoneLink>
  ) : (
    <OperatorLink data-testid="payment-method-operator" onClick={onClick}>
      {children}
    </OperatorLink>
  );

export default OperatorWrapper;
